import React, {useState} from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Outlet from "../../static/DropDown/outlet.svg";

function OutletSelectorM(props) {
  

 const {options, setoutlet, outlet, setFocusOutletSel} = props

  return (
    <div className="outlet-parent">
        <img alt="sdf" src={Outlet} />
        <span className="select-store">Select store</span>
        <span className="right-border"></span>
      {options.length > 0 && (
        <Autocomplete
          onChange={(event, newValue) => {
            
            setoutlet(newValue);
          }}
          id="controllable-states-demo"
          options={options}
          renderInput={(params) => <TextField {...params} variant="standard" />}
          getOptionLabel={(option) => option.outletName}
          value={outlet}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          onFocus={()=>{setFocusOutletSel(true)}}
          onBlur={()=>{setFocusOutletSel(false)}}
        />
      )}
    </div>
  );
}

export default OutletSelectorM;
